import React from "react"
import { createPortal } from "react-dom"
import Backdrop from "./Backdrop"

const ModalWrapper = ({ children, onClick }) => {
    return createPortal(
        <Backdrop onClick={onClick}>{children}</Backdrop>,
        document.getElementById("portal"),
    )
}

export default ModalWrapper
